import React from "react";
import Loader from "@components/LoaderComponent/loader";
import { FormatWithCommas } from "@helpers/helpers";
import clsx from "clsx";
import { DEFAULT_Z_INDEX } from "./constants";
import { X } from "lucide-react";

const PopupComponent = ({
  externalClassName,
  open,
  cellData,
  value,
  setPopupOpen,
  rawValue,
  addBlur = false,
  hideCellValue,
  popupLoading = false,
  z = DEFAULT_Z_INDEX,
  innerHtml,
}) => {
  return popupLoading ? (
    <Loader dots withContainer />
  ) : open ? (
    <div
      className={`fixed inset-0 flex items-center justify-center cursor-default`}
      style={{
        zIndex: z,
      }}
    >
      <div
        className={clsx(
          `absolute w-screen h-dvh bg-gray-800 bg-opacity-75 z-[-1]`,
          addBlur && "backdrop-filter backdrop-blur-sm"
        )}
        onClick={() => {
          setPopupOpen && setPopupOpen(false);
        }}
      ></div>

      <div
        data-testid="info-popup-component"
        className={clsx(
          `relative dark:bg-gray-800 bg-white max-w-[95vw] max-h-[90vh] p-5 px-8 rounded shadow-lg z-[20] overflow-y-auto`,
          cellData?.column?.columnDef?.popupClassName,
          !!externalClassName && externalClassName
        )}
      >
        <X
          className="absolute cursor-pointer top-2 right-2 dark:text-white text-gray-600 hover:text-red-500 hover:scale-125 transition-transform duration-500 h-6 w-6"
          onClick={() => {
            setPopupOpen && setPopupOpen(false);
          }}
        />
        <div className="mt-5">
          {innerHtml ? (
            <div dangerouslySetInnerHTML={{ __html: innerHtml }}></div>
          ) : rawValue ? (
            rawValue
          ) : (
            cellData.column.columnDef.popupContent(cellData.row.original)
          )}
        </div>
      </div>
    </div>
  ) : (
    !hideCellValue && (
      <span
        className="cursor-pointer underline underline-offset-4"
        onClick={() => {
          setPopupOpen && setPopupOpen(cellData.cell.id);
        }}
      >
        {rawValue
          ? rawValue
          : cellData.column.columnDef.popupCellDisplay(
              cellData.column.columnDef.showThousandSeperator
                ? FormatWithCommas(value)
                : value
            )}
      </span>
    )
  );
};

export default PopupComponent;
